// Who sells Zugzwang subscriptions, in one place for the app: the terms of
// sale, the angrerett text and withdrawal form, and the privacy policy all read
// it. The server keeps the same details for the emails it sends
// (functions/lib/billing-emails.js, SELLER) — functions/test/billing.test.js
// checks the two agree, and refuses BILLING_OPEN while the organisation number
// or the town is missing.
//
// The seller is an ENK (enkeltpersonforetak), not registered for MVA, so no
// price anywhere says "incl. VAT": there is none to include.

export const SELLER = Object.freeze({
    /** The ENK's registered name (foretaksnavn). */
    name: 'Zugzwang Misha Galinsky',
    /** Organisasjonsnummer from Enhetsregisteret, nine digits. */
    orgNumber: '822 099 912',
    street: 'Osloveien 34 A',
    postcode: '3511',
    town: 'Hønefoss',
    /** Given before purchase and in the confirmation, as angrerettloven § 8 c asks. */
    phone: '+47 989 96 498',
    email: 'misha@zugzwang.no'
});

/** "Osloveien 34A, 3511 Hønefoss" — the geographic address the law asks for. */
export function sellerAddress() {
    const place = [SELLER.postcode, SELLER.town].filter(Boolean).join(' ');
    return [SELLER.street, place].filter(Boolean).join(', ');
}

/** "Misha Galinsky, org.nr. 123 456 789" — name, and the number once there is one. */
export function sellerName() {
    return SELLER.orgNumber ? `${SELLER.name}, org.nr. ${SELLER.orgNumber}` : SELLER.name;
}

/** Everything on one line: name, number, address, phone, email. */
export function sellerLine() {
    return [sellerName(), sellerAddress(), SELLER.phone, SELLER.email].filter(Boolean).join(', ');
}
